import { css } from '@emotion/react';

import { palette } from './theme';

/** 공통 스타일 */
export const titleStyle = css`
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
`;

export const deleteButtonWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    background: ${palette.colorDanger};
    &:hover,
    &:active {
      background: red;
    }
  }
`;
